export default {
  location: [1, 2],
  status: true,
  logo: true,
  logoPath: "http://192.168.1.6:83/img/honmi_logo.png",
  logoWidth: 100,
  lang: true,
  search: true,
  shopcart: true,
  account: true,
  float: true,
  bgColor: "#fff",
  textColor: "#050505",
  hoverTextColor: "#b4a172",
  pcPaddingTop: 8,
  pcPaddingBottom: 8
};